import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b879769"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-box" }
const _hoisted_2 = {
  key: 0,
  class: "empty-view-wrapper"
}

import { computed, markRaw, onMounted } from 'vue'
import type { Component } from 'vue'
import NoPermission from '@/components/content/NoPermission.vue'
import EmptyView from '@teams/common/components/error/empty.vue'
// import WONormalIframe from '@/components/content/WONormalIframe.vue'
import WOIframe from '@/components/content/WOIframe.vue'
import KdocsIframe from '@/components/content/KdocsIframe.vue'
import UpdatesIframe from '@/components/content/Updates.vue'
import CreateNav from '@/components/content/CreateNav.vue'
import AccountChangePrompt from '@/components/content/accountChangePrompt/main.vue'
import { NavViewMode, useNavigatorStore } from '@/store/navigator'
import useViewManager from '@teams/common/hooks/useViewManager'
import useMitt from '@/hooks/useMitt'
import { events } from '@/constants'
import useNav from '@/components/navigator/useNav'
import { useStorage } from '@vueuse/core'
import { Nav } from '@teams/common/models'
import { useUserStore } from '@/store/user'
import { changeUrlQuery } from '@teams/common/utils/url'
import { getNavInfo } from '@teams/common/api'
import { useAccountChange } from '@teams/common/hooks/useAccountChange'
type ComponentProps = {
  url: string
  useShadowDOM?: boolean
  fileType?: string
  navParams: Record<string, unknown>
  navId: number
  data?: Record<string, any>
  [key: string]: any
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NavContent',
  props: {
    groupId: null,
    navId: null
  },
  setup(__props: any) {

const props = __props as {
  groupId: number
  navId: number
}

const userStore = useUserStore()
const { toViewContent } = useNav()
const emitter = useMitt()
const { multiState } = useAccountChange()


const navigatorStore = useNavigatorStore()
const activeNav = computed(() =>
  navigatorStore.list.find(nav => nav.id === props.navId)
)
const fileNameChange = async (name: string) => {
  // 标签为自动命名时
  const { data } = await getNavInfo(props.groupId, props.navId)
  if (data.auto_update) {
    navigatorStore.updateNav(
      props.navId,
      {
        name,
        auto_update: data.auto_update,
        nav_update_type: 0
      },
      { refresh: false }
    )
    navigatorStore.mutate(props.navId, { name })
  }
}
const component = computed(() => {
  let component: Component = WOIframe
  // let component: Component = WONormalIframe
  if (!activeNav.value) {
    return null
  }
  const { type, url, id, params, readonlyUrl } = activeNav.value
  // 'https://docs.wps.cn/l/cbzCOIDWXUa4?readonly'
  // 'https://docs.wps.cn/l/cbzCOIDWXUa4'
  const props: ComponentProps = {
    url,
    useShadowDOM: false,
    navParams: params,
    navId: id
  }
  let key = `${id}`
  if (!type) {
    component = NoPermission
  } else if (type === 'folder') {
    component = KdocsIframe
  } else if (type === 'file') {
    key = 'woIframe'
    // props.url = url + '&from=wps_team_app&simple&hidecmb&readonly'
    props.ext = params.ext
    props.onFileNameChange = fileNameChange
    // TODO: 1220全部放开编辑
    if (navigatorStore.viewModeMap[id] === NavViewMode.Write) {
      props.url = url
    } else {
      // 文档用只读url打开
      props.url = readonlyUrl
    }
    props.url = changeUrlQuery(props.url, { from: 'wps_team_app' })
  } else if (type === 'updates') {
    props.data = params
    component = UpdatesIframe
  } else if (type === 'blank') {
    component = CreateNav
  }

  return {
    key,
    component: markRaw(component),
    props,
    navId: id,
    navType: type
  }
})

const { componentList, componentMap, viewManager } = useViewManager(
  component,
  computed(() => props.navId)
)
emitter.on(events.removeNav, nav => {
  viewManager.remove(nav)
  // 删除当前显示视图时,跳转第一个
  if (!component.value) {
    const firstNav = (navigatorStore.list[0] || {}) as Nav
    toViewContent(firstNav)
  }
  // 删除nav同时删除对应的nid存储
  const treeWideState = useStorage(
    `folder_tree_width_${props.groupId}_${userStore.userId}`,
    {}
  )
  try {
    delete treeWideState.value[`nid${props.navId}`]
  } catch {
    console.log(
      `folder_tree_width_${props.groupId}_${userStore.userId} have no nid${props.navId}`
    )
  }
})
emitter.on(events.reloadNav, viewManager.reload)
emitter.on(events.updateNav, viewManager.update)

const kdocsIframeMessage = {
  // 云管理器面包屑路径改变
  pathChange: events.kdocsPathChange,
  // 目录树刷新节点
  TEAM_APP_REFRESH_MENU: events.kdocsRefreshMenu,
  // 目录树删除节点
  TEAM_APP_REMOVE_MENU: events.kdocsRemoveMenu,
  // 文件夹重命名
  TEAM_APP_FOLDER_RENAME: events.kdocsFolderRename
}

onMounted(() => {
  window.addEventListener('message', e => {
    try {
      const data = JSON.parse(e.data) || {}
      const { type, params, navId, source } = data
      if (source !== 'kdocs') {
        return
      }
      switch (true) {
        case !!kdocsIframeMessage[type]:
          emitter.emit(`${kdocsIframeMessage[type]}_${navId}`, { params })
          break
        default:
          break
      }
    } catch (e) {}
  })
})

return (_ctx: any,_cache: any) => {
  return (_unref(multiState).isChangeAccount)
    ? (_openBlock(), _createBlock(AccountChangePrompt, { key: 0 }))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(componentList), (item) => {
            return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(componentMap)[item].component), _mergeProps({
              class: { 'component--hide': _unref(componentMap)[item].navId !== props.navId },
              key: item
            }, _unref(componentMap)[item].props), null, 16, ["class"]))
          }), 128))
        ]),
        (!_unref(activeNav) && _unref(navigatorStore).listLoaded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(EmptyView, { class: "empty-view" })
            ]))
          : _createCommentVNode("", true)
      ], 64))
}
}

})